import React, { FC } from 'react';
import { Row } from 'Shared/components';
import styles from './styles.module.css';
import sharedStyles from '../styles/reportStyles.module.css';
import classNames from 'classnames';

type ReportDetailHeaderRowProps = {
  canChallenge?: boolean;
  includeRemove?: boolean;
  claim?: boolean;
  removeCheckSpacer?: boolean;
  shortSource?: boolean;
  rowClassName?: string;
};

export const ReportDetailHeaderRow: FC<ReportDetailHeaderRowProps> = ({
  canChallenge,
  children,
  includeRemove,
  claim = false,
  removeCheckSpacer = false,
  shortSource = false,
  rowClassName = '',
}) => (
  <div className={styles.wrapper}>
    {claim ? (
      <div className={styles.claimStatusSpacer}>Claim Status</div>
    ) : (
      !removeCheckSpacer && <div className={styles.checkSpacer} />
    )}
    <div
      className={classNames(styles.source, shortSource && styles.shortSource)}
    >
      Source
    </div>
    <div className={styles.content}>
      <Row className={rowClassName}>{children}</Row>
    </div>
    {canChallenge && (
      <div
        className={
          includeRemove ? sharedStyles.largeSpacer : sharedStyles.smallSpacer
        }
      />
    )}
  </div>
);
